import React, {useState, useEffect} from 'react'
// Styles
import './thd.style.css'
// Images
import ArrowBottomIcon from '../../assets/images/icons/arrow-b.png'

function TransHisDetails({ setOpenDetail, openDetail, detailData, refNo }) {
    let orderList = detailData && String(detailData.packages_name).split(",")
    const handleCloseDetails = () => {
        setOpenDetail(false);
        document.body.style.overflow = 'scroll'
    }

    return (
        <div className={`thd-container ${openDetail ? 'active' : ''}`}>
            {/* Close Button */}
            <span 
                className="cdt-switch"
                onClick={handleCloseDetails}
            >
                <img src={ArrowBottomIcon} />
            </span>

            {/* Header Text */}
            <h1 className="header-text">รายละเอียดคำสั่งซื้อ</h1>

            {/* card */}
            <div className="card">
                {/* detail top */}
                <div className="dt-top">
                    {/* paid status */}
                    <p className={`paid-status ${detailData && String(detailData.strstatus).trim() === 'ชำระเงินสำเร็จ' ? 'active' : ''}`}>{detailData && String(detailData.strstatus).trim()}</p>
                    {/* trans date */}
                    <p className="trs-date">วันที่ทำรายการ {detailData ? String(detailData.appointmentDate).split(' ')[0] : null}</p>
                    {/* trans ref */}
                    <p className="trs-ref">หมายเลขคำสั่งซื้อ : {detailData ? detailData.refNo : null}</p>
                    {/* detail label */}
                    <p className="dt-label">รายละเอียด</p>
                    {/* trs user info */}
                    <div className="trs-usr-info">
                        <div className="item">
                            <span className="label">ชื่อ-นามสกุล</span>
                            <span className="value">{detailData ? `${detailData.Firstname} ${detailData.Lastname}` : null}</span>
                        </div>
                        <div className="item">
                            <span className="label">วันเดือนปีเกิด</span>
                            <span className="value">{detailData ? detailData.Birthday : null}</span>
                        </div>
                        <div className="item">
                            <span className="label">เบอร์โทรศัพท์</span>
                            <span className="value">{detailData ? detailData.Phoneno : null}</span>
                        </div>
                        <div className="item">
                            <span className="label">อีเมล</span>
                            <span className="value">{detailData ? detailData.Email : null}</span>
                        </div>
                        <div className="item">
                            <span className="label">ช่องทางการชำระ</span>
                            <span className="value">ธนาคารไทยพาณิชย์</span>
                        </div>
                        <div className="item">
                            <span className="label">วันเวลาที่ชำระ</span>
                            <span className="value">{detailData ? detailData.PayDate+' น.' : null}</span>
                        </div>
                    </div>
                </div>
                {/* detail bottom */}
                <div className="dt-bottom">
                    {/* package list */}
                    <p className="label">รายการแพ็คเกจ</p>
                    {orderList !== null && orderList.map((od, i) => 
                        <p className="value" key={i} >{od}</p>
                    )}
                    <p className="tt-price">ราคารวมทั้งหมด  <span className="value">{detailData && Number(detailData.netPrice).toLocaleString('th', {minimumFractionDigits: 2})}</span></p>
                </div>
            </div>
        </div>
    )
}

export default TransHisDetails